// extracted by mini-css-extract-plugin
export default {"blue-checkbox":"_checkbox-blue-checkbox-bf39f6","checked":"_checkbox-checked-cf2181","inline-checkbox":"_checkbox-inline-checkbox-9ad1b5"};